import { RaffleDefaultFloatOfferBox } from "@components/raffles/default/floatOfferBox";
import { IRaffleDefaultDTO, IRaffleDefaultTicketDTO } from "@hooks/dtos/raffles/IRaffleDefaultDTO";
import { IRaffleTicketFilter } from "@hooks/dtos/raffles/IRaffleGeneralDTO";
import { RaffleDefaultTicketStatusEnum } from "@hooks/enums/raffle_default_ticket";
import { getRaffleDefaultTicketStatus } from "@hooks/functions/Raffle/status";
import { useMemo } from "react";
import { FiCheck, FiPlus, FiShoppingCart } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { NamedTicketLabel, NumericTicketLabel } from "./TicketChoiceLabel";

interface IProps {
  raffle: IRaffleDefaultDTO;
  raffleKey: string;
  tickets: IRaffleDefaultTicketDTO[];
  ticketsForRow: number;
  selectedTickets?: string[];
  onSelectedTicketsChange: (value: string[]) => void;
  canSelectTickets?: boolean;
}

export function RaffleDefaultTickets({ raffle, raffleKey, tickets, selectedTickets = [], onSelectedTicketsChange, canSelectTickets = true }: IProps) {
  const navigate = useNavigate();
  const isWord = raffle.type === "default_word";
  const priceValues = useMemo(() => ({ priceGross: raffle.price * selectedTickets.length, discount: 0, price: raffle.price * selectedTickets.length }), [raffle.price, selectedTickets.length]);

  const toggleTicket = (ticket: string) => onSelectedTicketsChange(selectedTickets.includes(ticket) ? selectedTickets.filter((item) => item !== ticket) : [...selectedTickets, ticket]);
  const buyTicket = (ticket: string) => navigate("/raffle/checkout", { state: { raffle, raffleKey, campaign: raffle.campaign, selectedTickets: selectedTickets.includes(ticket) ? selectedTickets : [...selectedTickets, ticket] } });

  return (
    <>
      <div className={`visit-ticket-grid ${isWord ? "visit-ticket-grid-word" : ""}`}>
        {tickets.map((ticket) => {
          const available = ticket.status === RaffleDefaultTicketStatusEnum.AVAILABLE;
          const selected = selectedTickets.includes(ticket.ticket);
          const status = getRaffleDefaultTicketStatus(ticket.status);
          return (
            <div className={`visit-ticket-tile ${selected ? "is-selected" : ""} ${!available ? "is-unavailable" : ""}`} key={`${ticket.order}-${ticket.ticket}`} title={status.title}>
              <button type="button" className="visit-ticket-select" disabled={!available || !canSelectTickets} onClick={() => toggleTicket(ticket.ticket)} aria-pressed={selected} aria-label={`${selected ? "Desmarcar" : "Marcar"} bilhete ${ticket.ticket}`} title={available && canSelectTickets ? `${selected ? "Desmarcar" : "Marcar"} bilhete ${ticket.ticket}` : status.title}>
                <span className="visit-ticket-mark">{selected ? <FiCheck /> : available && canSelectTickets ? <FiPlus /> : <span className="visit-ticket-dot unavailable" />}</span>
                <span className="visit-ticket-text">{isWord ? <NamedTicketLabel ticket={ticket} /> : <NumericTicketLabel ticket={ticket} />}{!available && <small>{status.text}</small>}</span>
              </button>
              {available && canSelectTickets && <button type="button" className="visit-ticket-buy" onClick={() => buyTicket(ticket.ticket)} title={`Fechar compra com o bilhete ${ticket.ticket}`} aria-label={`Fechar compra com o bilhete ${ticket.ticket}`}><FiShoppingCart /></button>}
            </div>
          );
        })}
      </div>
      {canSelectTickets && <RaffleDefaultFloatOfferBox raffle={raffle} raffleKey={raffleKey} selectedTickets={selectedTickets} values={priceValues} visibilityStatus={selectedTickets.length > 0} />}
    </>
  );
}
